import React from "react";

const App = () => {
  return <div>Code Hero Rebuild</div>;
};

export default App;
